import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function formatInternationalNumber(number, defaultCountry) {
    if (!number) return number;

    try {
        const parsedNumber = parsePhoneNumberFromString(number, defaultCountry);
        if (parsedNumber) {
            return parsedNumber.formatInternational();
        }
    } catch (error) {
        // Log the error if needed
        console.error('Error formatting phone number:', error);
        return number;
    }
    return number;
}
